import * as server from '../entries/pages/docs/_...slug_/_page.server.ts.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/_...slug_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/docs/[...slug]/+page.server.ts";
export const imports = ["_app/immutable/nodes/5.Du1gE726.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/D0QH3NT1.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/BwpWoHbM.js","_app/immutable/chunks/DC8ybcx3.js"];
export const stylesheets = ["_app/immutable/assets/5.DkJvrRWy.css"];
export const fonts = [];
